package frontend.lib

import net.sergeych.ugdx.shared.Currency
import net.sergeych.ugdx.shared.trader.CurrencyPair

private val currencyDisplayAliases = mapOf(
    "AED" to "USD",
    "mgAu" to "GRAIN",
)

fun displayCurrencyCode(code: String): String = currencyDisplayAliases[code] ?: code

fun displayCurrencyCode(currency: Currency): String = displayCurrencyCode(currency.code)

fun displayCurrencyAliases(text: String): String =
    currencyDisplayAliases.entries.fold(text) { result, (actual, alias) ->
        result.replace(actual, alias)
    }

fun displayCurrencyPair(pair: CurrencyPair): String =
    "${displayCurrencyCode(pair.base)}/${displayCurrencyCode(pair.quote)}"
